import { useEffect } from 'react'
import { groupManager } from '../components/Groups/GroupManager'
import { useAppStore } from '../store/appStore'
import { isReadOnly } from '../models/UserModel'

export const useGroupsInit = () => {
    const userModel = useAppStore((state) => state.userModel)

    useEffect(() => {
        if (!userModel?.org_id || isReadOnly(userModel)) return
        groupManager.fetchGroups()
    }, [userModel])
}
